import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/invite/group")({
  // Don't redirect authenticated users - they can accept group invitations
  component: GroupInviteLayout,
});

function GroupInviteLayout() {
  return <Outlet />;
}
